module.exports = __webpack_public_path__ + "img/w3_chevron_down_light.5e71551c.5e71551c.png";